import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { EnvironmentService } from 'Utilities/environment.service';
import { BC_API, OC_API } from 'OpsCenter/app.constants';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private environmentService: EnvironmentService) {
  }

  /**
   * @desc Function to intercept any httpclient request and apply routing logic
   * @param {HttpRequest} request - Original HttpRequest
   * @param {HttpHandler} next - Next interceptor
   * @return {Observable}
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    var url: string = request.url;
    const method: string = request.method;

    // Clone request and attach token as header
    if (url && url.startsWith('oc-api/')) {
      url = url.replace('oc-api/', '');
      url = `${this.environmentService.getEnvironment().OC_API}${url}`;

      request = request.clone({
        setHeaders: {
          'X-Quandoo-Authtoken': OC_API.TOKEN,
          'X-Quandoo-User-Session': localStorage.getItem('token'),
        },
        url,
      });
    }

    if (url && url.startsWith('bc-api/')) {
      url = url.replace('bc-api/', '');
      url = `${this.environmentService.getEnvironment().BC_API}${url}`;

      request = request.clone({
        setHeaders: {
          'X-Quandoo-Authtoken': BC_API.TOKEN,
          'X-Quandoo-User-Session': localStorage.getItem('token'),
        },
        url,
      });

    }
    return next.handle(request);
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/token.interceptor.ts